import forEach from "lodash/forEach";
export default (graphComponentRef) => {
    var _a;
    const regularNodesMap = {};
    const regularUngroupedNodesMap = {};
    const groupedNodesMap = {};
    const nodesSourceMap = {};
    (_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph.nodes.forEach(item => {
        if (!item.tag)
            return;
        if (item.tag.GroupId && item.tag.Nodes) {
            groupedNodesMap[item.tag.GroupId] = item;
            forEach(item.tag.Nodes, (node) => {
                nodesSourceMap[node.NodeId] = node;
            });
            return;
        }
        if (item.tag.NodeId) {
            regularNodesMap[item.tag.NodeId] = item;
            nodesSourceMap[item.tag.NodeId] = item.tag;
        }
        if (item.tag.GroupId && item.tag.NodeId) {
            if (!regularUngroupedNodesMap[item.tag.GroupId])
                regularUngroupedNodesMap[item.tag.GroupId] = {};
            regularUngroupedNodesMap[item.tag.GroupId][item.tag.NodeId] = item;
        }
    });
    return { regularNodesMap, regularUngroupedNodesMap, groupedNodesMap, nodesSourceMap };
};
